import { Select as MuiSelect, SelectProps as MuiSelectProps, styled } from "@mui/material";
import React, { ReactNode } from "react";

const StyledSelect = styled(MuiSelect)<{ error?: boolean }>(({ theme, error }) => {
  return {
    boxShadow: "none",
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "& .MuiInputBase-root": {
      color: error ? theme.palette.common.black : "inherit",
      backgroundColor: error ? theme.palette.error.light : "inherit",
    },
    "& .MuiSelect-select": {
      color: error ? theme.palette.common.black : "inherit",
    },
  };
});

interface BorderlessSelectProps extends Omit<MuiSelectProps, "children"> {
  placeholder?: string;
  children?: ReactNode;
  error?: boolean;
}

export const BorderlessSelect: React.FC<BorderlessSelectProps> = ({
  children,
  error,
  ...props
}) => {
  return (
    <StyledSelect displayEmpty error={error ?? false} {...props}>
      {children}
    </StyledSelect>
  );
};

export const renderSelectValue =
  (placeholder: string, renderSelected?: (value: unknown) => ReactNode) => (selected: unknown) => {
    if (selected === "" || selected === undefined) {
      return <span>{placeholder}</span>;
    }
    return renderSelected ? renderSelected(selected) : (selected as ReactNode);
  };

export default BorderlessSelect;
